import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { TaskDetails } from '../../../classes/models/admin/TaskDetails';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TaskDetailsAdapter } from '../../../classes/adapters/response/admin/TaskDetailsAdapter';

/**
 * This service communicates with backend to manage all administrative tasks.
 */
@Injectable({
  providedIn: 'root'
})
export class PredictionTaskService {
  private http = inject(HttpClient);
  private taskDetailsAdapter = inject(TaskDetailsAdapter);

  url = environment.apiUrl + '/predictions/tasks';

  /**
   * Resets the task of the given type.
   * @param taskType the type of task to be reset.
   */
  resetTask(taskType: string): Observable<void> {
    const url = `${this.url}/${taskType}/reset`;
    return this.http.post<void>(url, {});
  }

  /**
   * Disables the task of the given type. This prevents it from being executed in the future, until {@link enableTask} is executed.
   * @param taskType the type of the task to be disabled.
   */
  disableTask(taskType: string): Observable<void> {
    const url = `${this.url}/${taskType}/disable`;
    return this.http.post<void>(url, {});
  }

  /**
   * Enables task of the given type. This allows it to be run again after it has been blocked by {@link disableTask}.
   * @param taskType the type of task to be enabled.
   */
  enableTask(taskType: string): Observable<void> {
    const url = `${this.url}/${taskType}/enable`;
    return this.http.post<void>(url, {});
  }

  /**
   * Retrieves a list of all task details.
   */
  getTasksDetails(): Observable<TaskDetails[]> {
    const url = `${this.url}/details`;
    return this.http.get(url).pipe(
      map((data: []) => data.map(this.taskDetailsAdapter.adapt)));
  }
}

